<nav class="navbar bg-body-tertiary fixed-top">
  <div class="container-fluid">
    <img
      src="../../../assets/images/CTS_MexGMD_Offset_Blk.png"
      alt="Bootstrap"
      width="120"
      height="55"
      style="cursor: pointer"
      routerLink="/"
    />
    <div class="d-flex gap-3">
      <div class="input-icon autocomplete">
        <input
          autocomplete="off"
          class="form-control input-search"
          type="text"
          name="searching"
          (input)="keyPress()"
          (focus)="isActive()"
          [(ngModel)]="blTextFilter"
          placeholder="Buscar..."
          aria-label="Search"
          list="options"
        />
        <datalist id="options">
          <option *ngFor="let option of searchOptions" [value]="option">
        </datalist>
        <i class="bi bi-search"></i>
      </div>
      <app-notification-dropdown></app-notification-dropdown>
      <img
        class="user-default-photo"
        src="../../../assets/images/user-default.png"
        alt="Imagen de usuario por defecto"
      />
    </div>
  </div>
</nav>
